import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetThirdPartyCorrespondenceDetailsAsync,
  IThirdPartyCorrespondenceDetails,
} from "../../api/IThirdPartyCorrespondence";
import { RootState } from "../store";

export interface ThirdPartyCorrespondenceState {
  fetchStatus: string;
  thirdPartyCorrespondence?: IThirdPartyCorrespondenceDetails;
}

const initialState: ThirdPartyCorrespondenceState = {
  fetchStatus: "Loading...",
  thirdPartyCorrespondence: undefined,
};

export const loadThirdPartyCorrespondenceAsync = createAsyncThunk(
  "thirdPartyCorrespondence/load",
  async (thirdPartyCorrespondenceId: string) => {
    const response = await GetThirdPartyCorrespondenceDetailsAsync(
      thirdPartyCorrespondenceId
    );
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const thirdPartyCorrespondenceSlice = createSlice({
  name: "thirdPartyCorrespondence",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadThirdPartyCorrespondenceAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadThirdPartyCorrespondenceAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.thirdPartyCorrespondence = action.payload;
      });
  },
});

export const selectThirdPartyCorrespondence = (state: RootState) =>
  state.thirdPartyCorrespondence;

export default thirdPartyCorrespondenceSlice.reducer;
